
<template>
    <q-page class="presupuesto-crud-page bg-gradient q-pa-md">
        <div class="q-mb-lg text-h3 text-bold text-primary text-shadow">Presupuesto #{{ presup?.id }}</div>
        <div class="row q-col-gutter-xl q-mb-lg">
            <div class="col">
                <DatosObra
                    :presup="presup"
                    :tiene-confirmados="obraTieneConfirmado"
                    @obra-updated="updateVista()"
                    class="crud-card"
                />
            </div>
            <div class="col">
                <DatosPresupuesto
                    :presup="presup"
                    :total-emp="totalEmp"
                    @presup-updated="updateVista"
                    class="crud-card"
                />
            </div>
        </div>
        <div class="row q-col-gutter-xl">
            <div class="col">
                <DatosItems
                    :presup="presup"
                    @item-deleted="updateVista"
                    @item-updated="updateVista"
                    class="crud-card"
                />
            </div>
        </div>
    </q-page>
</template>


<script setup>
import DatosPresupuesto from "./DatosPresupuesto.vue";
import DatosObra from "./DatosObra.vue";
import DatosItems from "./DatosItems.vue";
import { router } from "@inertiajs/vue3";

const { presup, total, totalEmp, obraTieneConfirmado } = defineProps({
    presup: Object,
    total: Number,
    totalEmp: Array,
    obraTieneConfirmado: Boolean,
});
const updateVista = () => {
    router.visit(`/presupuestos/${presup.id}`, { only: ["presup"] });
};

</script>

<style lang="scss" scoped>
.presupuesto-crud-page {
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    min-height: 100vh;
}
.text-shadow {
    text-shadow: 0 2px 8px rgba(44, 62, 80, 0.12);
}
.crud-card {
    box-shadow: 0 4px 24px rgba(44, 62, 80, 0.10);
    border-radius: 18px;
    transition: box-shadow 0.2s;
    &:hover {
        box-shadow: 0 8px 32px rgba(44, 62, 80, 0.18);
    }
}
</style>
